import { gql } from '@efficiently/client-core-graphql-models';

/**
 * How many Design Change cards one scope (Project Bid) serves on its Scope Creep read, and how many of
 * them are submitted to the General Contractor, read without loading the cards themselves.
 *
 * Guarded server-side by `ProjectBidView` and `DesignChangeView` together. Non-null on the wire
 * (`Int!` both), so neither count needs a null check.
 */
export const PROJECT_BID_DESIGN_CHANGE_CARDS_SUMMARY = gql(`
	query ProjectBidDesignChangeCardsSummary($projectBidId: ID!) {
		projectBidDesignChangeCardsSummary(projectBidId: $projectBidId) {
			cardCount
			submittedToGcCardCount
		}
	}
`);
